import * as React from 'react'
import { Link } from 'react-router-dom'
import ButtonBlueWithIcon from '../ui/ButtonBlueWithIcon'
import Edit from '../icons/drivers/Edit'
import Archive from '../icons/drivers/Archive'
import RestoreFromArchive from '../icons/drivers/RestoreFromArchive'
import { IDriverSearchObject, IHistoryDriverTrips } from '../../types'
import DriverViewNavigationTabs from './DriverViewNavigationTabs'
import { Route, RouteComponentProps, Switch } from 'react-router'
import DriverViewPersonalInfo from '../../containers/drivers/DriverViewPersonalInfo'
import DriverViewProvidersProducts from '../../containers/drivers/DriverViewProvidersProducts'
import DriverViewSessionHistoryOld from 'src/containers/drivers/DriverViewSessionHistoryOld'
import BackToList from '../ui/BackToList'
import DriverViewSessionHistory from 'src/containers/drivers/DriverViewSessionHistory'
import PreloaderCircle from '../ui/PreloaderCircle'
import DriverViewSchedule from 'src/containers/drivers/DriverViewSchedule'
import DriverViewLocation from 'src/containers/drivers/DriverViewLocation'

export interface IDriverViewProps {
  getDriverById: (id: string) => void
  getTripsHistoryDriver: () => void
  historyDriverTrips: IHistoryDriverTrips[]
  isHistoryDriverTripsRequesting: boolean
  routeProps: RouteComponentProps<any>
  selectHistoryTrip: (historyTrip: IHistoryDriverTrips) => () => void
  selectedTrip: IHistoryDriverTrips
  archiveDriver: (driver: IDriverSearchObject) => Promise<any>
  restoreDriverFromArchive: (driver: IDriverSearchObject) => Promise<any>
  driverInfo: IDriverSearchObject
  loading: boolean
  loadingError: string
}

interface IDriverViewState {
  // Added a local state for future use
  loading: boolean
}

class DriverView extends React.Component<IDriverViewProps, IDriverViewState> {
  public state: IDriverViewState = {
    loading: true
  }

  constructor(props: IDriverViewProps) {
    super(props)
  }

  public async componentDidMount() {
    await this.props.getTripsHistoryDriver()
    await this.props.getDriverById(this.props.routeProps.match.params.id)
    this.setState({
      loading: false
    })
  }

  public render() {
    if (!this.props.driverInfo) {
      return null
    }

    const operator = this.props.driverInfo

    const styles = {
      CirclePreLoader: {
        display: 'flex',
        paddingTop: '5px',
        flex: 1,
        justifyContent: 'center',
        alignment: 'center',
        width: '100%'
      }
    }

    if (this.props.loading) {
      return (
        <div style={styles.CirclePreLoader}>
          <PreloaderCircle loading={true} />
        </div>
      )
    }

    return (
      <div className='fit-height'>
        <BackToList link='/drivers' className='flex' />
        <div className='flex items-center justify-between px2'>
          <div className='flex items-center justify-between'>
            <div className='h3 font-blue-grey'>{operator.name}</div>
          </div>
          <div className='flex'>
            {!operator.isArchived ? (
              <div className='flex'>
                <Link to={this.redirectPath()}>
                  <ButtonBlueWithIcon title={'Edit'}>
                    <Edit className='icon--16x16' />
                  </ButtonBlueWithIcon>
                </Link>

                <div onClick={this.handleClickDriver(operator, this.props.archiveDriver)}>
                  <ButtonBlueWithIcon title={'Move to Archive'}>
                    <Archive className='icon--16x16' />
                  </ButtonBlueWithIcon>
                </div>
              </div>
            ) : (
              <div className='flex'>
                <div onClick={this.handleClickDriver(operator, this.props.restoreDriverFromArchive)}>
                  <ButtonBlueWithIcon title={'Restore from Archive'}>
                    <RestoreFromArchive className='icon--16x16' />
                  </ButtonBlueWithIcon>
                </div>
              </div>
            )}
          </div>
        </div>
        <DriverViewNavigationTabs
          path={this.props.routeProps.match.url}
          location={this.props.routeProps.location.pathname}
        />
        <div>
          <Switch>
            <Route
              exact={true}
              path={`${this.props.routeProps.match.path}/details`}
              component={DriverViewPersonalInfoWrapper}
            />
            <Route
              path={`${this.props.routeProps.match.path}/products`}
              component={DriverViewProvidersProductsWrapper}
            />
            <Route
              path={`${this.props.routeProps.match.path}/session-history-old`}
              component={DriverViewSessionHistoryWrapperOld}
            />
            <Route
              path={`${this.props.routeProps.match.path}/session-history`}
              component={DriverViewSessionHistoryWrapper}
            />
            <Route path={`${this.props.routeProps.match.path}/schedule`} component={DriverViewScheduleWrapper} />
            <Route path={`${this.props.routeProps.match.path}/location`} component={DriverViewLocationWrapper} />
          </Switch>
        </div>
      </div>
    )
  }

  private handleClickDriver = (driver: IDriverSearchObject, action: any) => () => {
    action(driver)
    this.props.routeProps.history.push('/drivers')
  }

  private redirectPath = () => {
    // to={`/drivers/${operator.id}/edit`}
    // const { location } = this.props
    const { driverInfo } = this.props

    if (/\/details/.test(window.location.pathname)) {
      return `/drivers/${driverInfo.id}/edit`
    } else if (/\/products/.test(window.location.pathname)) {
      return `/drivers/${driverInfo.id}/edit/products`
    } else if (/\/session-history/.test(window.location.pathname)) {
      return `/drivers/${driverInfo.id}/edit/session-history`
    } else if (/\/schedule/.test(window.location.pathname)) {
      return `/drivers/${driverInfo.id}/edit/schedule`
    }
    return window.location.pathname
  }
}

const DriverViewPersonalInfoWrapper = (props: RouteComponentProps<any>) => (
  <DriverViewPersonalInfo driverId={props.match.params.id} />
)

const DriverViewProvidersProductsWrapper = (props: RouteComponentProps<any>) => (
  <DriverViewProvidersProducts operatorId={props.match.params.id} />
)

const DriverViewSessionHistoryWrapperOld = (props: RouteComponentProps<any>) => (
  <DriverViewSessionHistoryOld operatorId={props.match.params.id} />
)

const DriverViewSessionHistoryWrapper = (props: RouteComponentProps<any>) => (
  <DriverViewSessionHistory operatorId={props.match.params.id} {...props} />
)

const DriverViewScheduleWrapper = (props: RouteComponentProps<any>) => (
  <DriverViewSchedule operatorId={props.match.params.id as string} />
)

const DriverViewLocationWrapper = (props: RouteComponentProps<any>) => (
  <DriverViewLocation operatorId={props.match.params.id as string} />
)

export default DriverView



// WEBPACK FOOTER //
// ./src/components/drivers/DriverView.tsx